import { render, staticRenderFns } from "./SetLocation.vue?vue&type=template&id=94404434&lang=pug&"
import script from "./SetLocation.vue?vue&type=script&lang=js&"
export * from "./SetLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports